var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"anzahl-badge",class:{
      'anzahl-badge--mehrere': _vm.anzahl > 1,
      'anzahl-badge--clickable': _vm.isClickable,
    },on:{"click":function($event){$event.stopPropagation();return _vm.onBadgeClick.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.anzahl)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }